import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Grid, Card, Typography, Box, Divider, Stack, Button, Snackbar, Alert } from '@mui/material';
import ScheduleIcon from '@mui/icons-material/Schedule';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import CodeIcon from '@mui/icons-material/Code';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import OpportunityModal from './projectsOpportunityModel';
import {
  IoTdevelopercourses,
  IoTDataScientistcourses,
  IndustrialiotCourses,
} from "../../iotLearningPath/Courses/coursesdata";

import {
  IoTdeveloperProjects,
  IoTDataScientistProjects,
  IndustrialProjects,
} from "../../iotLearningPath/Courses/projectsData";
import getLearningPathData from "../../iotLearningPath/dashboard/api";
import { OrganizationsallprojectsCompanyProject, Organizationapplied, Organizationapplyprojects } from "../../../../../helper/base_url";

const PostProjects = () => {
  const [selectedOption] = useState(localStorage.getItem("selectedLearningPath") || "");
  const [responseData, setResponseData] = useState({ HOE: 0 });
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOpportunity, setSelectedOpportunity] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [stickyMessageIndex, setStickyMessageIndex] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [appliedHiringIds, setAppliedHiringIds] = useState([]);

  useEffect(() => {
        axios
            .get(`${OrganizationsallprojectsCompanyProject}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            })
            // .then((response) => {
            //     setProjects(response.data.data);
            //     setLoading(false);
            // })
            .then((response) => {
                const activeProjects = response.data.data.filter(project => project.status === 'Active');
                setProjects(activeProjects);
                setLoading(false);
                //console.log("Projects fetched successfully:", activeProjects);
            })
            .catch(() => {
                //setError('Error fetching data');
                setLoading(false);
            });

          const fetchAppliedJobs = async () => {
            try {
              const res = await axios.get(`${Organizationapplied}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
              });
        
              const ids = res.data.ListOfprojectId || [];
              const hiringIds = ids.map(id => id._id || id);
              setAppliedHiringIds(hiringIds);
            } catch (err) {
              // console.error("Failed to fetch applied jobs:", err);
            }
          };
          fetchAppliedJobs();
    }, []);

    useEffect(() => {
    if (selectedOption) {
      const fetchData = async () => {
        try {
          switch (selectedOption) {
            case "IoT Developer / Engineer":
              getLearningPathData(
                selectedOption,
                IoTdevelopercourses[0]?.courses || [],
                IoTdeveloperProjects[0]?.projects || [],
                setResponseData
              );
              break;
            case "IoT Data Scientist":
              getLearningPathData(
                selectedOption,
                IoTDataScientistcourses[0]?.courses || [],
                IoTDataScientistProjects[0]?.projects || [],
                setResponseData
              );
              break;
            case "Industrial IoT & Industry 4.0":
              getLearningPathData(
                selectedOption,
                IndustrialiotCourses[0]?.courses || [],
                IndustrialProjects[0]?.projects || [],
                setResponseData
              );
              break;
            default:
              console.log(`Invalid learning path in localStorage: "${selectedOption}"`);
          }
        } catch (error) {
          console.error("Error fetching learning path data:", error);
        }
      };

      fetchData();
    }
  }, [selectedOption]);

const handleApplyClick = async (companyId, projectId) => {
  if (responseData.HOE < 75) {
    setStickyMessageIndex(projectId);
    setTimeout(() => setStickyMessageIndex(null), 5000);
    return;
  }

  try {
    const res = await axios.post(`${Organizationapplyprojects}`, {
      companyId,
      projectId
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });

    setSnackbar({
      open: true,
      message: res.data.message || "Application submitted successfully!",
      severity: 'success'
    });

    // Mark as applied
    setAppliedHiringIds(prev => [...prev, projectId]);
  } catch (error) {
    console.error("Application error:", error.response?.data || error.message);
    setSnackbar({
      open: true,
      message: error.response?.data?.error || "Failed to apply",
      severity: 'error'
    });
  }
};

  const handleOpenModal = (project) => {
    setSelectedOpportunity(project);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  if (loading) return <Typography align="center" mt={4}>No project opportunities available at the moment....</Typography>;
  if (projects.length === 0) return <Typography align="center" mt={4}> No Projects available.</Typography>;

 return (
  <>
  <Grid container spacing={4} padding="10px 20px">
    {projects.length === 0 ? (
      <Grid item xs={12}>
        <Typography align="center" mt={3}>
          No Projects available.
        </Typography>
      </Grid>
    ) : (
      projects.map((project, index) => (
        <Grid item xs={12} sm={6} md={6} key={project._id || index}>
          <Card
            sx={{
              borderRadius: 3,
              p: 3,
              boxShadow: 6,
              '&:hover': { boxShadow: 10, transform: 'translateY(-5px)' },
              transition: '0.3s ease-in-out',
              backgroundColor: '#ffffff',
            }}
          >
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography variant="h6" fontWeight="600" color="#052659" fontSize="1rem" paddingRight="20px">
                  {project.projectTitle}
                </Typography>
              </Box>
              {/* <Avatar
                src={project.companyLogoUrl || '/default-logo.png'}
                alt="Company Logo"
                variant="rounded"
                sx={{ width : 60, height : 60 }}
              /> */}
            </Box>

            <Divider sx={{ my: 2 }} />
               {/* <Box>
                  <Typography variant="caption" color="text.secondary">Company Name</Typography>
                  <Typography variant="body2">{projects.companyName}</Typography>
                </Box> */}
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2} paddingRight="40px" flexWrap="wrap">
              <Box display="flex" alignItems="center" gap={1}>
                <ScheduleIcon sx={{ color: "#6A6CFF" }} />
                <Box>
                  <Typography variant="caption" color="text.secondary">Duration</Typography>
                  <Typography variant="body2">{project.projectDuration || '-'}</Typography>
                </Box>
              </Box>

              <Box display="flex" alignItems="center" gap={1} width="200px">
                <WorkOutlineIcon sx={{ color: "#6A6CFF" }} />
                <Box>
                  <Typography variant="caption" color="text.secondary">Industry</Typography>
                  <Typography variant="body2">{project.domain}</Typography>
                </Box>
              </Box>

              <Box display="flex" alignItems="center" gap={1}>
                <LaptopMacIcon sx={{ color: "#6A6CFF" }} />
                <Box>
                  <Typography variant="caption" color="text.secondary">Mode</Typography>
                  <Typography variant="body2">{project.modeOfWork}</Typography>
                </Box>
              </Box>
            </Stack>

            <Stack direction="row" spacing={2} mb={2}>
              <Box display="flex" alignItems="center" gap={1}>
                <CodeIcon sx={{ color: "#6A6CFF" }} />
                <Box>
                  <Typography variant="caption" color="text.secondary">Languages</Typography>
                  <Typography variant="body2">{project.preferredProgrammingLanguages}</Typography>
                </Box>
              </Box>
            </Stack>

            <Stack direction="row" justifyContent="space-between" alignItems="center" mt={2}>
              <Button
                variant="outlined"
                size="small"
                onClick={() => handleOpenModal(project)}
              >
                View Details
              </Button>

              {appliedHiringIds.includes(project._id) ? (
                <Button
                  variant="contained"
                  size="small"
                  disabled
                  sx={{
                    backgroundColor: "#ccc",
                    borderRadius: "16px",
                    textTransform: "none",
                    fontSize: "0.7rem",
                    padding: "4px 12px",
                  }}
                >
                  Applied
                </Button>
              ) : (
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => handleApplyClick(project.companyId, project._id)}
                  sx={{
                    backgroundColor: "#6A6CFF",
                    borderRadius: "16px",
                    textTransform: "none",
                    fontSize: "0.7rem",
                    padding: "4px 12px",
                  }}
                  endIcon={<ArrowForwardIcon fontSize="small" />}
                >
                  Apply
                </Button>
              )}
            </Stack>
          </Card>

          {stickyMessageIndex === project._id && (
            <Box
              sx={{
                position: 'fixed',
                top : 80,
                left : '50%',
                transform: 'translateX(-50%)',
                backgroundColor: '#fff1f2',
                color: '#b91c1c',
                padding: '10px 16px',
                fontSize: '13px',
                fontWeight: 600,
                boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
                zIndex: 1000,
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                gap: "10px",
              }}
            >
              <PriorityHighIcon fontSize="small" sx={{ color: '#b91c1c' }} />
              Reach 75% HOE Score to become eligible for Project opportunities. Keep going!
            </Box>
          )}
          <Snackbar
            open={snackbar.open}
            autoHideDuration={4000}
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
          <Alert
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            severity={snackbar.severity}
            sx={{ width : '100%' }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
        </Grid>
      ))
    )}
  </Grid>

  <OpportunityModal
    open={openModal}
    onClose={handleCloseModal}
    projects={selectedOpportunity}
  />
</>
);
}
export default PostProjects;

